/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionCustomerGranteesQuery from '../graphql/queries/GetSouscriptionCustomerGranteesQuery.js';

const useGetSouscriptionCustomerGranteesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionCustomerGranteesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionCustomerGrantees: R.omit(['__typename'], data?.getSouscriptionCustomerGrantees_souscription_customer_grantees || {})
  };
};

export default useGetSouscriptionCustomerGranteesQuery;
